module.exports = __webpack_public_path__ + "img/map02.01da0057.png";